/* product-detail.js — Produktseite (eigenes File, eingebunden in product-detail.liquid)
   Pro Feature ein IIFE mit Kommentar-Header; alle Blöcke defensiv (Guards),
   damit nichts crasht, wenn ein Element fehlt. Vanilla, kein Build. */

// --- Feature: Produkt-Galerie (Indikator-Striche + Pfeile) ---
(function () {
  var galleries = document.querySelectorAll('[data-gallery]');
  if (!galleries.length) return;

  galleries.forEach(function (gallery) {
    var images = gallery.querySelectorAll('[data-gallery-image]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (images.length < 2) return;

    var index = 0;
    var preloadedMedia = [];
    var hasPreloadedMedia = false;

    function preloadRemainingMedia() {
      if (hasPreloadedMedia) return;
      hasPreloadedMedia = true;

      images.forEach(function (media, mediaIndex) {
        if (mediaIndex === 0) return;

        var image = media.querySelector('img');
        if (image) {
          image.loading = 'eager';

          var preloadImage = new Image();
          if (image.srcset) preloadImage.srcset = image.srcset;
          if (image.sizes) preloadImage.sizes = image.sizes;
          preloadImage.src = image.currentSrc || image.src;
          preloadedMedia.push(preloadImage);
        }

        var video = media.querySelector('video');
        if (video) {
          video.preload = 'auto';
          video.load();
        }

        var iframe = media.querySelector('iframe');
        if (iframe) iframe.loading = 'eager';
      });
    }

    var firstImage = images[0].querySelector('.product-detail__image');
    var firstVideo = images[0].querySelector('video');
    var firstFrame = images[0].querySelector('iframe');

    if (firstImage && !firstImage.complete) {
      firstImage.addEventListener('load', preloadRemainingMedia, { once: true });
      firstImage.addEventListener('error', preloadRemainingMedia, { once: true });
    } else if (firstVideo && firstVideo.readyState < 2) {
      firstVideo.addEventListener('loadeddata', preloadRemainingMedia, { once: true });
      firstVideo.addEventListener('error', preloadRemainingMedia, { once: true });
    } else if (firstFrame) {
      firstFrame.addEventListener('load', preloadRemainingMedia, { once: true });
    } else {
      preloadRemainingMedia();
    }

    function show(i) {
      index = ((i % images.length) + images.length) % images.length;
      images.forEach(function (img, k) {
        img.hidden = k !== index;
        img.classList.toggle('is-active', k === index);
        var video = img.querySelector('video');
        if (!video) return;
        if (k !== index) {
          video.pause();
          return;
        }
        video.play().catch(function () {});
      });
      dots.forEach(function (dot, k) {
        dot.classList.toggle('is-active', k === index);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-gallery-dot'), 10) || 0);
      });
    });

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  });
})();

// --- Feature: Warenkorb-Link unter dem Produkt-Button (Desktop + Tablet) ---
(function () {
  var links = document.querySelectorAll('[data-product-cart-link]');
  if (!links.length) return;

  var badge = document.querySelector('[data-cart-count]');

  function update(count) {
    var hasItems = Math.max(0, Number(count) || 0) > 0;
    links.forEach(function (link) {
      link.hidden = !hasItems;
    });
  }

  function updateFromBadge() {
    if (!badge) return;
    update(badge.hidden ? 0 : badge.textContent);
  }

  document.addEventListener('seelchen:cart-updated', function (event) {
    update(event.detail && event.detail.count);
  });

  if (badge && typeof MutationObserver !== 'undefined') {
    new MutationObserver(updateFromBadge).observe(badge, {
      attributes: true,
      attributeFilter: ['hidden'],
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  updateFromBadge();
})();

// --- Feature: Echtes Shopify-Produkt zum Warenkorb hinzufügen ---
(function () {
  var forms = document.querySelectorAll('[data-product-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var variantInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-cart-button]');
    var label = form.querySelector('[data-cart-button-label]');
    if (!variantInput || !variantInput.value || !button) return;

    var defaultLabel = label ? label.textContent : '';
    var successTimer;

    function showAddedFeedback() {
      if (!label) return;

      window.clearTimeout(successTimer);
      label.textContent = '✓';
      button.setAttribute('aria-label', 'Added to cart');
      successTimer = window.setTimeout(function () {
        label.textContent = defaultLabel;
        button.removeAttribute('aria-label');
      }, 1200);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (button.disabled) return;

      window.clearTimeout(successTimer);
      if (label) label.textContent = defaultLabel;
      button.removeAttribute('aria-label');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function () {
          showAddedFeedback();
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart read failed');
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('seelchen:cart-updated', {
            detail: { count: cart.item_count }
          }));
        })
        .catch(function () {
          window.clearTimeout(successTimer);
          button.removeAttribute('aria-label');
          if (label) label.textContent = 'Please try again';
        })
        .finally(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    });
  });
})();
